// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "bulma-tooltip";


document.addEventListener("turbolinks:load", () => {
  const forms = document.querySelectorAll(".submit-one-time");
  forms.forEach(form => {
    form.addEventListener("submit", e => {
      const el = e.target;
      const button = el.querySelector("*[type='submit']");
      if (button) {
        button.disabled = true;
        if (button.tagName.toLowerCase() == "input") {
          button.value = "送信しています";
        } else {
          button.text = "送信しています";
        }
      }
    });
  });

  const items = document.querySelectorAll("*[data-toggle-disabled]");
  items.forEach(item => {
    const trigger = item.dataset.toggleTrigger;
    if (trigger) {
      document.querySelector(trigger).addEventListener("change", e => {
        item.disabled = !e.target.checked;
      });
    }
  });
});
